import React, { useState, useEffect } from 'react';
import { FormInput } from '@snsw/react-component-library';
import styles from './InputValidation.module.scss';
import PropTypes from 'prop-types';

const localErrorMsg = {
  alphabetsErrorMsg: 'Input should only contain alphabets',
  numericErrorMsg: 'Input should only contain numbers',
  minLengthErrorMsg: 'Min length shoule be'
};

const InputValidation = ({ ...props }, ref) => {
  const { minLength, alphabet, numeric, firstValidation = true, errorMessage, hasError = true, errorHandler } = props;
  const [val, setVal] = useState('');
  const [errorMsg, setErrorMsg] = useState(props.errorMessage ?? '');
  const [localHasError, setLocalHasError] = useState(false);
  const { alphabetsErrorMsg, numericErrorMsg, minLengthErrorMsg } = localErrorMsg;

  const checkOnlyAlp = (str) => !!str.match(/[^a-zA-Z]/);
  const checkOnlyNum = (str) => !!str.match(/[^0-9]/);

  useEffect(() => {
    setLocalHasError(false);
    if (val.length && firstValidation && hasError) {
      if (val.length < minLength) {
        setLocalHasError(true);
        setErrorMsg(errorMessage || `${minLengthErrorMsg} ${minLength}`);
      }
      // if (val.length > maxLength) {
      //   setLocalHasError(true);
      //   setErrorMsg(`Max length shoule be ${maxLength}`);
      // }
      if (alphabet && checkOnlyAlp(val)) {
        setLocalHasError(true);
        setErrorMsg(errorMessage || alphabetsErrorMsg);
      }
      if (numeric && checkOnlyNum(val)) {
        setLocalHasError(true);
        setErrorMsg(errorMessage || numericErrorMsg);
      }
    }
  }, [val, hasError, firstValidation]);

  useEffect(() => {
    errorHandler(localHasError);
  }, [localHasError]);

  const handleInputchange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    }
    setVal(e.target.value);
  };

  return (
    <div className={`${styles.formContainer} ${props.className ?? ''}`}>
      <div className={`${styles.inputContainer} inputContainer`}>
        <FormInput
          {...props}
          value={val}
          onChange={handleInputchange}
          errorMessage={errorMsg}
          hasError={localHasError}
        />
      </div>
    </div>
  );
};

InputValidation.propTypes = {
  minLength: PropTypes.number,
  alphabet: PropTypes.bool,
  numeric: PropTypes.bool,
  firstValidation: PropTypes.bool,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool
};

export default InputValidation;
